import { createContext, useContext } from 'react'

import type { ComboboxFieldOption } from './types'

type ComboboxFieldSelectionContextValue = {
    selectedOptions: ComboboxFieldOption[]
    isHydratingValue: boolean
}

export const ComboboxFieldSelectionContext = createContext<ComboboxFieldSelectionContextValue | null>(null)

export function useComboboxFieldSelection(): ComboboxFieldSelectionContextValue {
    const context = useContext(ComboboxFieldSelectionContext)
    return context ?? { selectedOptions: [], isHydratingValue: false }
}

export function useResolvedComboboxFieldSelectedOptions(options: {
    isAsyncMode: boolean
    selectedValueCount: number
    fallbackSelectedOptions: ComboboxFieldOption[]
}) {
    const { isAsyncMode, selectedValueCount, fallbackSelectedOptions } = options
    const { selectedOptions: contextSelectedOptions, isHydratingValue } = useComboboxFieldSelection()

    const selectedOptions =
        isAsyncMode && contextSelectedOptions.length > 0 && contextSelectedOptions.length === selectedValueCount
            ? contextSelectedOptions
            : fallbackSelectedOptions

    return {
        selectedOptions,
        isHydratingValue,
    }
}
